import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../config';
import type { RegistrationRequest } from './apiTypes';
import { handleResponse, prepareHeaders } from './apiServiceUtils';
import type { AccessToken } from '../configuration/tokenHandling/tokenSlice';
import { accessToken } from '../configuration/tokenHandling/accessToken';

export const registrationApi = createApi({
    reducerPath: 'registrationApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.IAM_BASE_URL, prepareHeaders }),
    endpoints: builder => ({
        sendRegistration: builder.mutation<
            { user_id: string; account_id: string; warnings?: { code: string; message: string }[] },
            RegistrationRequest
        >({
            query: postBody => ({
                url: '/registrations',
                method: 'POST',
                body: postBody,
                responseHandler: async (response: Response) => handleResponse(response),
            }),
        }),
        // Mutation for registrations with test tenant.
        //  This endpoint is secured with scope checks.
        sendTestRegistration: builder.mutation<
            { user_id: string; account_id: string; warnings?: { code: string; message: string }[] },
            RegistrationRequest
        >({
            query: postBody => {
                const token = accessToken.getAccessToken() as AccessToken;
                return {
                    url: '/test-registrations',
                    method: 'POST',
                    body: postBody,
                    headers: { authorization: `Bearer ${token}` },
                    responseHandler: async (response: Response) => handleResponse(response),
                };
            },
        }),
    }),
});

export const { useSendRegistrationMutation, useSendTestRegistrationMutation } = registrationApi;
